import { BulkDeleteService } from './bulk-delete.service';
import { Row } from '@vendasta/galaxy/table';
import { CRMSelectAllOptions, ObjectType, SelectAllAction } from '@galaxy/crm/static';

export function BulkDeleteAll(
  namespace: string,
  service: BulkDeleteService,
  objectType: string,
  label: string,
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], options?: CRMSelectAllOptions) => {
      service.bulkDeleteDialog(namespace, objectType as ObjectType, options);
    },
  };
}
